export function byline({
  author,
  publication
}: {
  author?: string;
  publication?: string;
}) {
  return [author, publication].filter(Boolean).join(' • ');
}
